import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-label',
  templateUrl: './custom-label.component.html',
  styleUrls: ['./custom-label.component.css']
})
export class CustomLabelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

}
